import { formatDate } from '@/utils/date'

export function first4Chars(str) {
  return str ? str.substring(0, 4) : ''
}

export function formatDateTime(time) {
  if (!time) return 'N/A'
  const date = new Date(time.replace(' ', 'T'))

  const hours = date.getHours()
  const minutes = date.getMinutes()
  const ampm = hours >= 12 ? 'PM' : 'AM'
  const formattedHours = hours % 12 || 12
  const formattedMinutes = minutes.toString().padStart(2, '0')

  const formattedDate = formatDate(date, 'yyyy/MM/dd')
  return `${formattedDate} ${formattedHours}:${formattedMinutes} ${ampm}`
}

export function formatDateOnly(time) {
  if (time == null || time === '') return 'N/A'
  return formatDate(new Date(time), 'yyyy/MM/dd')
}

export function toDefaultCurrency(value) {
  if (typeof value !== 'number') return value
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
}

export function toLakhCurrency(value) {
  if (typeof value !== 'number') return value
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'MMK' }).format(value)
}

export function formatCurrency(value) {
  if (!value || value == 0 || value === '0') return ''
  return Number(value).toLocaleString('en-US')
}

export function toLakh(value) {
  if (typeof value !== 'number') return value
  if (value === 0) return ''
  const lakhValue = value / 100000
  return lakhValue % 1 === 0
    ? lakhValue + ' Lks'
    : lakhValue.toFixed(3) + ' Lks'
}
